// extracted by mini-css-extract-plugin
export default {"Wrapper":"ItemImage_Wrapper__1KOHO","Image":"ItemImage_Image__tL8Tv"};